"use client";
import React from 'react';
import { motion } from 'framer-motion';
import { useContactModal } from '@/contexts/ContactModalContext';

const CLASH = 'var(--font-clash), "Clash Display", sans-serif';
const MANROPE = 'var(--font-manrope), Manrope, sans-serif';
const MONO = '"SF Mono", "Roboto Mono", Menlo, Consolas, monospace';
const LIME = '#ceff1a';
const INK = '#080400';

export default function AnalyticsCTA() {
    const { openModal } = useContactModal();

    return (
        <section
            className="relative overflow-hidden py-20 md:py-28 px-4 md:px-16 lg:px-24"
            style={{ background: INK }}
        >
            <div className="absolute inset-0 pointer-events-none opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle, rgba(206,255,26,1) 1px, transparent 1px)', backgroundSize: '36px 36px' }} />
            <div className="max-w-[900px] mx-auto relative z-10 text-center flex flex-col gap-10 items-center">
                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-sm"
                    style={{ fontFamily: MONO, color: LIME }}
                >
                    $ get_in_touch
                </motion.span>
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1 }}
                    className="text-2xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight"
                    style={{ fontFamily: CLASH, color: '#ffffff' }}
                >
                    Know What Your Marketing Is Actually Driving
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.15 }}
                    className="text-base md:text-lg max-w-2xl"
                    style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.6)', lineHeight: '1.8', letterSpacing: '0.02em' }}
                >
                    Let&apos;s build a measurement system that connects marketing activity to the outcomes your business cares about.
                </motion.p>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 }}
                    className="flex flex-col sm:flex-row gap-4 items-center w-full sm:w-auto"
                >
                    <button
                        onClick={openModal}
                        className="inline-flex items-center justify-center w-full sm:w-auto px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 hover:scale-105"
                        style={{ background: LIME, color: INK, fontFamily: CLASH, letterSpacing: '0.05em' }}
                    >
                        Get a Performance Marketing Analytics Audit →
                    </button>
                </motion.div>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 }}
                    className="text-xs"
                    style={{ fontFamily: MANROPE, color: 'rgba(255,255,255,0.3)', letterSpacing: '0.05em' }}
                >
                    Lead Workz — Build for visibility. Optimised for revenue.
                </motion.p>
            </div>
        </section>
    );
}
